export const haptics = {
  light: () => {
    if (navigator.vibrate) navigator.vibrate(10);
  },
  medium: () => {
    if (navigator.vibrate) navigator.vibrate(20);
  },
  success: () => {
    if (navigator.vibrate) navigator.vibrate([15, 50, 30]);
  },
  warning: () => {
    if (navigator.vibrate) navigator.vibrate([30, 20, 30]);
  },
};
